var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4445 12.2962C21.4074 12.3912 21.354 12.4767 21.2867 12.548L14.4658 19.773C14.3236 19.9237 14.1365 20 13.9494 20C13.7623 20 13.5752 19.9247 13.4329 19.773C13.1474 19.4705 13.1474 18.9802 13.4329 18.6778L19.0065 12.774H3.23081C2.8274 12.774 2.5 12.4272 2.5 11.9999C2.5 11.5726 2.8274 11.2258 3.23081 11.2258H19.0056L13.4319 5.32195C13.1464 5.01954 13.1464 4.52923 13.4319 4.22681C13.7175 3.9244 14.1803 3.9244 14.4658 4.22681L21.2867 11.4518C21.354 11.523 21.4074 11.6086 21.4445 11.7035C21.5185 11.8935 21.5185 12.1063 21.4445 12.2962Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.d4e7e0b6080da9b3cafa66df3a1b6609.svg";
export { ForwardRef as ReactComponent };